import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { ArrowButton, CollapseButton } from "Buttons";
import styled, {css} from "styled-components";
import MapBlocksToComponents from "Helpers/BlockHelper";
import { StandardImage } from "Components/StandardImage";
import useBreakpoint from "Hooks/useBreakpoint";

import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { RTEWrapper, ContentWrapper, ElementAreaWrapper } from "BaseComponents/Wrappers";
import { Ingress, PageHeader } from "BaseComponents/Text/";

const LinkWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 16px;
	${media.greaterThan(breakpoints.mobile)`
		grid-template-columns: repeat(3, minmax(0, 1fr));
  `}
	${media.greaterThan(breakpoints.ipad)`
		grid-template-columns: repeat(3, minmax(0, 1fr));
	`}
`;
const CollapseWrapper = styled.div`
	position: relative;
	overflow: hidden;
	margin-top: 16px;
	transition: 0.5s;
	height: 0;
	${({ active, height }) => active && height && css`
		height: ${({ height }) => height}px;
	`}
`;
const CollapseBlock = styled.div`
	transform: translateY(-100%);
	transition: 0.5s;
	${({ active }) => active && css`
		transform: translateY(0%);
	`}	
`;
const Icon = styled.i`
    display: flex;
    align-items: center;
    gap: 10px;
	transform: rotate(90deg);
	font-size: 21px;
	transition: .4s;
	${({ expanded }) => expanded && css`
		transform: rotate(270deg);
	`}	
`
let PassagePage = ({ Heading, Preamble, Text, Image, ImageText, Children, TopElementArea, ReadMoreHereText, LoadMoreText, CloseText }) => {
	const isMobile = useBreakpoint("mobile");
	const collapseRef = useRef(null);
	const [isExpended, setIsExpended] = useState(false);
	const [showLoadMoreBtn, setShowLoadMoreBtn] = useState(false);
	const [linksLimit, setLinksLimit] = useState(isMobile ? 1 : 3);
	const [linksToShow, setLinksToShow] = useState(Children.slice(0, linksLimit) || []);
	const [collapseHeight, setCollapseHeight] = useState(0);

	useEffect(() => {
		if(Children?.length > linksLimit) {
			setShowLoadMoreBtn(true);
		}
		setCollapseHeight(collapseRef?.current?.clientHeight);
	}, []);

	useEffect(() => {
		const limit = isMobile ? 1 : 3;
		setLinksLimit(limit);
		setLinksToShow(Children.slice(0, limit) || []);
	}, [isMobile]);

	useEffect(() => {
		setCollapseHeight(collapseRef?.current?.clientHeight);
	}, [linksLimit]);

	const showMore = () => {
		setIsExpended(!isExpended);
	}

	return (
		<>
			<PageHeader Heading={Heading} margin="0 0 15px 0" />
			<LinkWrapper>
				{linksToShow?.map((link, i) => {
					return <ArrowButton key={i} {...link} ReadMoreHereText={ReadMoreHereText} />;
				})}
			</LinkWrapper>
			<CollapseWrapper height={collapseHeight} active={isExpended}>
				<CollapseBlock ref={collapseRef} active={isExpended}>
					<LinkWrapper>
						{Children.slice(linksLimit, Children?.length)?.map((link, i) => {
							return <ArrowButton key={i} {...link} ReadMoreHereText={ReadMoreHereText} />;
						})}
					</LinkWrapper>
				</CollapseBlock>
			</CollapseWrapper>
			{showLoadMoreBtn ?
				<CollapseButton borderedRadius inverted onClick={showMore}>
					{!isExpended ? LoadMoreText : CloseText}
					<Icon className="icon-right-arrow" expanded={isExpended}/>
				</CollapseButton> :
				null}
			<ElementAreaWrapper>
				{TopElementArea.length > 0 && MapBlocksToComponents(TopElementArea)}
			</ElementAreaWrapper>
			{Preamble && (
				<Ingress
					marginSmall="0 0 15px 0"
					margin="0 0 10px 0"
					dangerouslySetInnerHTML={{
						__html: Preamble,
					}}
				></Ingress>
			)}
			<ContentWrapper>
				{Image && <StandardImage src={Image} byline={ImageText} />}
				{Text && (
					<RTEWrapper
						dangerouslySetInnerHTML={{
							__html: Text,
						}}
					></RTEWrapper>
				)}
			</ContentWrapper>
		</>
	);
};

PassagePage.propTypes = {
	Heading: PropTypes.string,
	Text: propTypes.string,
};

export default PassagePage;
